export function isSafePortalRedirect(value: string) {
	return value.startsWith('/') && value[1] !== '/' && value[1] !== '\\'
}
